;const eventTracking = (function(){

    let activeProduct = 0;

    const tagConfigs = pageData.configs;
    const confirmationPage = window.location.href.match( /(.*checkouts)(.*thank_you)/ );


    function init () {
        document.addEventListener('click', checkProduct);
        document.addEventListener('click', addProductToCart);
        document.addEventListener('click', removeProduct);
        document.addEventListener('click', checkoutStart);

        switch (pageData.pageType) {
            case 'collection':
                collectionView();
                break;
            case 'product':
                productView();
                break;
            case 'search': 
                searchPage();
                break;
            default:
                pageView();
                break;
        }
    }

    function pageView () {
        if (typeof window['ga'] === 'function') {
            ga('send', 'pageview', pageData.path);
        }

        if (confirmationPage) {
            purchase()
        }
    }

    function checkProduct (e) {
        if (e.target.classList.contains('quickview__button')) {
            const productCards = Array.from(document.querySelectorAll('.plp-product'));
            const productCard = e.target.closest('.plp-product');
            activeProduct = productCards.indexOf(productCard);
        }
    }

    function collectionView () {
        if (typeof window['ga'] === 'function') {
            for (let i = 0, total = pageData.items.length; i < total; i++) {
                const this_product = pageData.items[i];
                ga('ec:addImpression', this_product);
            }
            ga('ec:setAction', 'list');
            ga('send', 'pageview');
        }
    }

    function productView () {
        const productID = pageData.items[0].id;

        if (typeof window['ga'] === 'function') {
            ga('ec:addProduct', pageData.items[0]);
            ga('ec:setAction', 'detail');
            ga('send', 'pageview');
        }

        if (typeof window['fbq'] === 'function') {
            fbq('track', 'ViewContent', {
                content_type: 'product_group',
                content_ids: [productID],
                value: pageData.items[0].price,
                content_name: pageData.items[0].name + ' - ' + pageData.items[0].variant,
                currency: pageData.currency,
                content_category: pageData.items[0].category
            });
        }

        if (typeof window['gtag'] === 'function') {
            gtag('event', 'view_item', {
                'send_to': eventTags.adwords,
                'value': pageData.items[0].price,
                'items': [{
                    'id': pageData.items[0].id
                }]
            });
        }

        if (window.kenshoo) {
            kenshoo.trackConversion(eventTagsConfig.kenshoo.server, eventTagsConfig.kenshoo.token, {
                conversionType: 'product_view',
                product: pageData.items[0].id,
                value: pageData.items[0].price,
                currency: pageData.currency
            })
        }
        if (window.heap){
            heap.track("Product View", {
                product_sku: thisProduct.id,
                product_name: thisProduct.name,
                product_category: pageData.items[0].category
            });
        }
    }

    function addProductToCart (e) {
        const isAddToCart = e.target && (e.target.classList.contains('product-form__cart-submit') || e.target.querySelector("#AddToCartText-product-template"));
        if (isAddToCart || e.target.id === 'addToCartNav') {
            const thisProduct = pageData.items[activeProduct];
            const selected_qty = parseInt(document.getElementById('Quantity').value);
            thisProduct.quantity = selected_qty;

            if (typeof window['ga'] === 'function') {
                ga('ec:addProduct', thisProduct);
                ga('ec:setAction', 'add');
                ga('send', 'event', 'UX', 'click', 'add to cart');
            }

            if (typeof window['gtag'] === 'function') {
                gtag('event', 'add_to_cart', {
                    send_to: eventTags.adwords,
                    value: thisProduct.price,
                    currency: pageData.currency,
                    "items": [
                        {
                            id: thisProduct.id,
                            quantity: selected_qty
                        }
                    ],
                });
            }

            if (typeof window['fbq'] === 'function') {
                fbq('track', 'AddToCart', {
                    value: thisProduct.price,
                    content_type: 'product_group',
                    content_name: thisProduct.name + ' - ' + thisProduct.variant,
                    currency: pageData.currency,
                    content_category: pageData.items[0].category,
                    contents: [
                        {
                            id: thisProduct.id,
                            quantity: selected_qty
                        }
                    ],
                });
            }

            if (window.kenshoo) {
                kenshoo.trackConversion(eventTagsConfig.kenshoo.server, eventTagsConfig.kenshoo.token, {
                    conversionType: 'add_to_cart',
                    product: thisProduct.id,
                    quantity: selected_qty,
                    revenue: thisProduct.price,
                    currency: pageData.currency
                })
            }
        }
    }

    function removeProduct (e) {
        if (e.target.classList.contains('cart__remove')) {
            const linkData = new URLSearchParams(new URL(e.target.href).search);
            const productIndex = parseInt(linkData.get("line")) - 1;
            const thisProduct = pageData.items[productIndex];
            if (typeof window['ga'] === 'function') {
                ga('ec:removeProduct', thisProduct);
                ga('ec:setAction', 'remove');
                ga('send', 'event', 'UX', 'click', 'remove from cart');
            }

            if (typeof window['gtag'] === 'function') {
                gtag('event', 'remove_from_cart', {
                    send_to: eventTags.adwords,
                    value: thisProduct.price,
                    currency: pageData.currency,
                    "items": [
                        {
                            id: thisProduct.id,
                            quantity: selected_qty
                        }
                    ],
                });
            }
    
            if (typeof window['fbq'] === 'function') {
                fbq('track', 'RemoveFromCart', {
                    value: thisProduct.price,
                    content_name: thisProduct.name + ' - ' + thisProduct.variant,
                    currency: pageData.currency,
                    content_category: pageData.items[0].category,
                    contents: [
                        {
                            id: thisProduct.id,
                            quantity: selected_qty
                        }
                    ],
                });
            }

            if (window.kenshoo) {
                kenshoo.trackConversion(eventTagsConfig.kenshoo.server, eventTagsConfig.kenshoo.token, {
                    conversionType: 'remove_from_cart',
                    product: thisProduct.id,
                    quantity: selected_qty,
                    revenue: thisProduct.price,
                    currency: pageData.currency
                })
            }
            if(window.heap) {
                heap.track("Remove from Cart", {
                    product_sku: thisProduct.id,
                    product_name: thisProduct.name,
                    product_category: pageData.items[0].category
                });
            }
        }
    }

    function checkoutStart(e) {
        if (e.target.classList.contains('cart__checkout__btn')) {
            const value = pageData.items.reduce(function(prev, curr) {
                return prev + (curr.price ? curr.price : 0);
            }, 0);

            if (typeof window['gtag'] === 'function') {
                gtag('event', 'begin_checkout', {
                    send_to: eventTags.adwords,
                    value: value,
                    currency: pageData.currency,
                    "items": pageData.items
                });
            }

            if (typeof window['fbq'] === 'function') {
                fbq('track', 'InitiateCheckout', {
                    content_type: 'product_group',
                    content_ids: pageData.items.map(function(el) {
                        return el.id;
                    }),
                    contents: pageData.items,
                    num_items: pageData.items.length,
                    value: value,
                    currency: pageData.currency,
                    content_category: pageData.items[0].category
                });
            }

            if (window.kenshoo) {
                kenshoo.trackConversion(eventTagsConfig.kenshoo.server, eventTagsConfig.kenshoo.token, {
                    conversionType: 'start_checkout',
                    items: JSON.stringify(pageData.items),
                    revenue: value,
                    currency: pageData.currency
                })
            }
        }
    }

    function purchase () {
        if (typeof window['ga'] === 'function') {
            ga('ec:setAction', 'purchase', {
                id: window.purchaseObject.order_number,
                revenue: window.purchaseObject.value,
            });
            ga('send', 'pageview');
        }

        if (typeof window['fbq'] === 'function') {
            fbq('track', 'Purchase', {
                value: pageData.items[0].price,
                currency: pageData.currency,
                content_type: 'product_group',
                content_category: pageData.items[0].category,
                contents: pageData.items,
            });
        }

        if (typeof window['gtag'] === 'function') {
            gtag('event', 'conversion', {
                'send_to': eventTags.adwords + '/' + window.purchaseObject.order_number,
                'value': window.purchaseObject.value,
                'currency': pageData.currency,
                'transaction_id': window.purchaseObject.order_number
            });
            gtag('event', 'purchase', {
                'send_to': eventTags.adwords + '/' + window.purchaseObject.order_number,
                'value': window.purchaseObject.value,
                'currency': pageData.currency,
                'transaction_id': window.purchaseObject.order_number,
                'items': pageData.items
            });
        }

        if (window.kenshoo) {
            kenshoo.trackConversion(eventTagsConfig.kenshoo.server, eventTagsConfig.kenshoo.token, {
                conversionType: 'ks_conversion',
                items: JSON.stringify(pageData.items),
                revenue: window.purchaseObject.value,
                currency: pageData.currency,
                orderId: window.purchaseObject.order_name,
                promoCode: window.purchaseObject.discountCodes.map(code => code.code).join(","),
            })
        }

        window.dispatchEvent(new Event("checkout_complete", window.purchaseObject));
    }

    function getSearchTerm() {
        const match = window.location.search.match(new RegExp('q=(.*?)(&|$|#|\\?)', 'im'));
        return (match && match[1] && decodeURIComponent(match[1])) || '';
    }
  
    function searchPage() {
        let properties = {
            product_finding_method: 'Search',
            product_finding_method_pagename: 'Search Product Recs',
            product_finding_method_detail: 'Search Not Done'
        };

        const searchTerm = getSearchTerm();
        if(searchTerm && window.searchFilteredResults) {
            properties.product_finding_method_pagename = 'Search Results';
            properties.product_finding_method_detail = searchTerm.toLowerCase().replace(/\+/g, ' ');
        }

        document.querySelectorAll('.product a').forEach(function(product) {
            product.addEventListener('click', function() {
                if(window.heap) {
                    window.heap.addEventProperties(properties);
                }
            });
        });
    }

    const loaded = document.readyState !== 'loading';
    if(loaded){
        init();
    }else{
        document.addEventListener('DOMContentLoaded', init);
    }

    return{
        start : init,
        addView : pageView,
        addProduct : addProductToCart,
        removeProduct : removeProduct,
        makePurchase : purchase
    }

}());
